import * as AuthApi from '@/api/authApi';
import { vxm } from '@/stores';
import LoginResult from '@/models/loginResult';

class AuthService {
  public async authenticate(username: string, password: string): Promise<LoginResult> {
    let response = await AuthApi.authenticate(username, password);

    if(response.token){
      vxm.auth.setJwt(response.token);

      if(response.user){
        vxm.user.setUser(response.user);
      }
    } else {
      this.clearAuth();
    }

    return {
      success: this.isAuthenticated(),
      message: response.message
    };
  }

  public async validate(): Promise<LoginResult> {
    let response = await AuthApi.validate();

    if(response.user){
      vxm.user.setUser(response.user);
    } else {
      this.clearAuth();
    }

    return {
      success: this.isAuthenticated(),
      message: response.message
    };
  }

  public isAuthenticated(): boolean {
    return vxm.auth.isLoggedIn;
  }

  public hasUserDetails(): boolean {
    return vxm.user.hasUserDetails;
  }

  public clearAuth(): void {
    vxm.auth.clearJwt();
    vxm.user.clearUser();
  }
}

export const Singleton = new AuthService();